function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 214,
  width: 289,
  height: 1,
  fill: "#46C3D7",
  opacity: 0.2
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fillOpacity: 0.61,
  fillRule: "nonzero",
  opacity: 0.8,
  d: "M0 0H287.198V214.222H0z"
}), React.createElement("path", {
  d: "M254.73 68.562l32.497.2",
  stroke: "#FFF",
  strokeDasharray: "6 6",
  strokeLinecap: "round",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M0 201.374s70.693 2.378 105.702-33.665c35.01-36.043 71.707-98.738 139.776-99.203l9.253.056",
  stroke: "#DA46AC",
  strokeDasharray: "6 6",
  strokeLinecap: "round",
  strokeWidth: 2
}), React.createElement("g", {
  transform: "translate(125.712 100.15)",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M41.53.039l-3.65 1.35a9.134 9.134 0 0 0-3.657 2.496L13.356 27.348l-.732.532c-.726.528-1.607.8-2.504.773l-7.937-.235c-.363-.011-.713.14-.954.41l-1.183 1.33a.182.182 0 0 0 .053.284l7.61 3.933-1.517 2.433a.107.107 0 0 0 .02.137l.578.512c.036.032.09.036.13.01l7.101-4.65a38.116 38.116 0 0 0 7.6-6.557L36.447 9.592a49.88 49.88 0 0 0 5.916-8.193.995.995 0 0 0-.202-1.242.624.624 0 0 0-.63-.118z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M21.622 26.26L36.446 9.592a49.88 49.88 0 0 0 5.916-8.193.995.995 0 0 0-.202-1.242.624.624 0 0 0-.63-.118l-3.65 1.35a9.134 9.134 0 0 0-3.657 2.496l-.166.187.018.05c.952 2.59.4 5.492-1.434 7.555L13.587 33.1l.434-.284a38.116 38.116 0 0 0 7.6-6.557zm-10.494 5.728l-4.364 3.225-1.43 1.61 2.734-1.138a.74.74 0 0 0 .27-.191l2.965-3.335-.004.003a.123.123 0 0 0-.171-.174z",
  fill: "#00BED4"
}), React.createElement("path", {
  d: "M10.12 28.653l-3.59-.106 1.1.354a2.645 2.645 0 0 1 1.664 3.467l.277-.311 3.785-4.71-.732.533c-.726.528-1.607.8-2.504.773z",
  opacity: 0.1,
  fill: "#145569"
}), React.createElement("path", {
  fill: "#071920",
  opacity: 0.4,
  d: "M38.4778235 2.20799047L39.8539847 0.661003937 38.2732492 1.24302414 37.0944079 2.56777161z"
}), React.createElement("path", {
  d: "M35.512 3.361l.001-.001a.678.678 0 0 1 .956-.057l1.018.902a.676.676 0 0 1 .057.956v.001a.678.678 0 0 1-.956.057l-1.019-.902a.676.676 0 0 1-.057-.956z",
  fill: "#071920",
  opacity: 0.4
}), React.createElement("path", {
  d: "M12.842 28.852v-.001a.678.678 0 0 1 .956-.057l1.019.902a.676.676 0 0 1 .057.956l-.001.001a.678.678 0 0 1-.956.057l-1.018-.902a.676.676 0 0 1-.057-.956z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M27.359 13.505v-.001a.428.428 0 0 1 .603-.036l.456.404a.427.427 0 0 1 .036.603.428.428 0 0 1-.604.036l-.455-.403a.427.427 0 0 1-.036-.603z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M26.52 14.447l.157-.176a.31.31 0 0 1 .438-.026l.631.559c.129.113.14.309.027.437l-.157.176a.31.31 0 0 1-.438.026l-.631-.559a.309.309 0 0 1-.026-.437z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M34.77 5.706a.15.15 0 0 1 .213-.013l.109.096a.15.15 0 0 1 .012.212.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.212z",
  fill: "#071920"
}), React.createElement("path", {
  d: "M34.52 6.27l-.027-.025a.151.151 0 0 0-.249.082.15.15 0 0 0 .048.143l.108.096a.148.148 0 0 0 .133.031 7.432 7.432 0 0 0-.012-.327z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M34.6 6.34l-.08-.07c.007.109.012.218.013.327a.147.147 0 0 0 .08-.044.15.15 0 0 0-.012-.213z",
  fill: "#071920"
}), React.createElement("path", {
  d: "M33.789 6.809a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M33.298 7.36a.15.15 0 0 1 .213-.012l.109.096a.15.15 0 0 1 .012.213.15.15 0 0 1-.212.012l-.109-.096a.15.15 0 0 1-.013-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M32.808 7.912a.15.15 0 0 1 .212-.013l.109.097a.15.15 0 0 1 .013.212.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.012-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M32.317 8.464a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M31.799 9.047l.055-.062a.11.11 0 0 1 .154-.01l.17.151a.109.109 0 0 1 .01.154l-.055.063a.11.11 0 0 1-.155.009l-.17-.151a.109.109 0 0 1-.01-.154z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M31.308 9.599l.055-.063a.11.11 0 0 1 .155-.009l.17.151c.045.04.05.11.01.154l-.056.062a.11.11 0 0 1-.154.01l-.17-.151a.109.109 0 0 1-.01-.154z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M30.845 10.12v-.001a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M30.354 10.67a.15.15 0 0 1 .213-.012l.109.096a.15.15 0 0 1 .012.213.15.15 0 0 1-.212.013l-.109-.097a.15.15 0 0 1-.013-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M29.864 11.222a.15.15 0 0 1 .213-.013l.108.097a.15.15 0 0 1 .013.212.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M29.373 11.774a.15.15 0 0 1 .213-.013l.109.096a.15.15 0 0 1 .012.213.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M28.883 12.326a.15.15 0 0 1 .212-.013l.109.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.109-.097a.15.15 0 0 1-.012-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M28.392 12.877a.15.15 0 0 1 .213-.012l.108.096a.15.15 0 0 1 .013.212.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M27.625 13.74a.15.15 0 0 1 .212-.013l.109.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.012-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M26.865 14.595a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.212.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M26.089 15.467a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.012-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M25.598 16.019a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.108-.097a.15.15 0 0 1-.013-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M25.107 16.57a.15.15 0 0 1 .213-.012l.109.096a.15.15 0 0 1 .013.212.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.013-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M24.617 17.122a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.012-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M24.126 17.674a.15.15 0 0 1 .213-.013l.109.096a.15.15 0 0 1 .012.213.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M23.639 18.229a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.212.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.012-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M23.145 18.777a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M22.654 19.329a.15.15 0 0 1 .213-.013l.109.096a.15.15 0 0 1 .012.213.15.15 0 0 1-.212.013l-.109-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M22.164 19.88a.15.15 0 0 1 .212-.012l.109.096a.15.15 0 0 1 .013.212.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.012-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M21.673 20.432a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M21.182 20.984a.15.15 0 0 1 .213-.013l.109.096a.15.15 0 0 1 .012.213.15.15 0 0 1-.212.013l-.109-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M20.692 21.536a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.212.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.012-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M20.201 22.087a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M19.71 22.639a.15.15 0 0 1 .213-.013l.109.096a.15.15 0 0 1 .012.213.15.15 0 0 1-.212.013l-.109-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M19.22 23.19a.15.15 0 0 1 .213-.012l.108.096a.15.15 0 0 1 .013.212.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.012-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M18.73 23.742a.15.15 0 0 1 .212-.013l.109.096a.15.15 0 0 1 .012.213.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M18.239 24.294a.15.15 0 0 1 .212-.013l.109.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.012-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M17.748 24.846a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.212.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M17.257 25.397a.15.15 0 0 1 .213-.013l.109.097a.15.15 0 0 1 .012.212.15.15 0 0 1-.213.013l-.108-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M16.767 25.95v-.001a.15.15 0 0 1 .212-.013l.109.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.012-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M16.276 26.5a.15.15 0 0 1 .213-.012l.108.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.108-.097a.15.15 0 0 1-.013-.212z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M15.785 27.052a.15.15 0 0 1 .213-.013l.109.097a.15.15 0 0 1 .012.212.15.15 0 0 1-.212.013l-.109-.096a.15.15 0 0 1-.013-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M15.295 27.604a.15.15 0 0 1 .213-.013l.108.096a.15.15 0 0 1 .013.213.15.15 0 0 1-.213.013l-.109-.096a.15.15 0 0 1-.012-.213z",
  fill: "#145569",
  opacity: 0.1
}), React.createElement("path", {
  d: "M22.36 20.143a3.443 3.443 0 0 1-2.358.74l-3.3-.209a.584.584 0 0 0-.474.195l-.28.315a.057.057 0 0 0 .027.092l3.502.994c.376.107.78.06 1.122-.13l1.762-1.997z",
  fill: "#00BED4"
}), React.createElement("path", {
  d: "M31.489 12.894l-9.128 7.25-1.762 1.997 7.045-3.903a6.362 6.362 0 0 0 1.818-1.508l2.806-3.39a.367.367 0 0 0-.24-.599.727.727 0 0 0-.54.153z",
  fill: "#071920"
}), React.createElement("path", {
  d: "M29.855 17.883l.807-.908-1.55-1.374-3.326 3.739a.052.052 0 0 0 .048.086l1.693-.27a3.945 3.945 0 0 0 2.328-1.273z",
  fill: "#145569"
}), React.createElement("path", {
  d: "M32.05 15.915l1.065-1.2-2.048-1.813-4.39 4.936a.069.069 0 0 0 .063.115l2.236-.356a5.21 5.21 0 0 0 3.073-1.682z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M33.115 14.716c-.29.327-.95.183-1.533-.334-.584-.517-.805-1.153-.515-1.48.291-.327.95-.183 1.534.334.584.517.805 1.153.514 1.48z",
  fill: "#145569"
}), React.createElement("path", {
  d: "M31.812 13.561c-.08.09-.02.263.14.404.16.142.34.18.42.092a.375.375 0 0 0-.56-.495z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M6.192 36.808l.196-.313.857.759-.325.213a.108.108 0 0 1-.13-.01l-.578-.512a.107.107 0 0 1-.02-.137z",
  fill: "#145569"
})), React.createElement("g", {
  opacity: 0.2,
  transform: "translate(112.371 157.088)",
  stroke: "#46C3D7",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M59.5216927 17.8674411L59.5216927 3.03316498 40.3751335 3.03316498 40.3751335 57.1357071 58.8825793 57.1357071 59.5216927 57.1357071 72.2749421 57.1357071 72.2749421 17.8674411z"
}), React.createElement("path", {
  d: "M82.226 5.481H101.001V57.151H82.226z"
}), React.createElement("path", {
  d: "M84.692 0.262H98.535V5.48H84.692z"
}), React.createElement("path", {
  d: "M85.475 8.405H87.619V17.067H85.475z"
}), React.createElement("path", {
  d: "M90.541 8.405H92.685V17.067H90.541z"
}), React.createElement("path", {
  d: "M95.606 8.405H97.75V17.067H95.606z"
}), React.createElement("path", {
  d: "M85.475 19.635H87.619V28.297000000000004H85.475z"
}), React.createElement("path", {
  d: "M90.541 19.635H92.685V28.297000000000004H90.541z"
}), React.createElement("path", {
  d: "M95.606 19.635H97.75V28.297000000000004H95.606z"
}), React.createElement("path", {
  d: "M85.475 30.864H87.619V39.526H85.475z"
}), React.createElement("path", {
  d: "M90.541 30.864H92.685V39.526H90.541z"
}), React.createElement("path", {
  d: "M95.606 30.864H97.75V39.526H95.606z"
}), React.createElement("path", {
  d: "M85.475 42.094H87.619V50.756H85.475z"
}), React.createElement("path", {
  d: "M90.541 42.094H92.685V50.756H90.541z"
}), React.createElement("path", {
  d: "M95.606 42.094H97.75V50.756H95.606z"
}), React.createElement("path", {
  d: "M42.918 6.534H45.823V10.222H42.918z"
}), React.createElement("path", {
  d: "M48.647 6.534H51.552V10.222H48.647z"
}), React.createElement("path", {
  d: "M54.375 6.534H57.28V10.222H54.375z"
}), React.createElement("path", {
  d: "M42.918 13.91H45.823V17.598H42.918z"
}), React.createElement("path", {
  d: "M48.647 13.91H51.552V17.598H48.647z"
}), React.createElement("path", {
  d: "M54.375 13.91H57.28V17.598H54.375z"
}), React.createElement("path", {
  d: "M42.918 21.286H45.823V24.974H42.918z"
}), React.createElement("path", {
  d: "M48.647 21.286H51.552V24.974H48.647z"
}), React.createElement("path", {
  d: "M54.375 21.286H57.28V24.974H54.375z"
}), React.createElement("path", {
  d: "M42.918 28.662H45.823V32.35H42.918z"
}), React.createElement("path", {
  d: "M48.647 28.662H51.552V32.35H48.647z"
}), React.createElement("path", {
  d: "M54.375 28.662H57.28V32.35H54.375z"
}), React.createElement("path", {
  d: "M42.918 36.038H45.823V39.726H42.918z"
}), React.createElement("path", {
  d: "M48.647 36.038H51.552V39.726H48.647z"
}), React.createElement("path", {
  d: "M54.375 36.038H57.28V39.726H54.375z"
}), React.createElement("path", {
  d: "M42.918 43.413H45.823V47.101H42.918z"
}), React.createElement("path", {
  d: "M48.647 43.413H51.552V47.101H48.647z"
}), React.createElement("path", {
  d: "M54.375 43.413H57.28V47.101H54.375z"
}), React.createElement("path", {
  d: "M42.918 50.789H45.823V54.477000000000004H42.918z"
}), React.createElement("path", {
  d: "M48.647 50.789H51.552V54.477000000000004H48.647z"
}), React.createElement("path", {
  d: "M54.375 50.789H57.28V54.477000000000004H54.375z"
}), React.createElement("path", {
  d: "M60.288 21.286H63.193V24.974H60.288z"
}), React.createElement("path", {
  d: "M60.288 28.662H63.193V32.35H60.288z"
}), React.createElement("path", {
  d: "M60.288 36.038H63.193V39.726H60.288z"
}), React.createElement("path", {
  d: "M60.288 43.413H63.193V47.101H60.288z"
}), React.createElement("path", {
  d: "M60.288 50.789H63.193V54.477000000000004H60.288z"
}), React.createElement("path", {
  d: "M66.202 21.286H69.107V24.974H66.202z"
}), React.createElement("path", {
  d: "M66.202 28.662H69.107V32.35H66.202z"
}), React.createElement("path", {
  d: "M66.202 36.038H69.107V39.726H66.202z"
}), React.createElement("path", {
  d: "M66.202 43.413H69.107V47.101H66.202z"
}), React.createElement("path", {
  d: "M66.202 50.789H69.107V54.477000000000004H66.202z"
}), React.createElement("path", {
  d: "M59.522 15.095H73.783V17.764H59.522z"
}), React.createElement("path", {
  d: "M39.536 0.364H60.662000000000006V3.033H39.536z"
}), React.createElement("g", {
  transform: "translate(0 36.195)"
}, React.createElement("path", {
  d: "M2.374 5.255H31.764999999999997V20.955H2.374z"
}), React.createElement("path", {
  d: "M0.612 0.707H33.526V5.255H0.612z"
}), React.createElement("rect", {
  x: 6.828,
  y: 9.062,
  width: 4.557,
  height: 4.548,
  rx: 2.274
}), React.createElement("rect", {
  x: 14.994,
  y: 9.062,
  width: 4.557,
  height: 4.548,
  rx: 2.274
}), React.createElement("rect", {
  x: 23.285,
  y: 9.062,
  width: 4.557,
  height: 4.548,
  rx: 2.274
}))), React.createElement("path", {
  d: "M59.839 214.221l51.782-27.381c13.307-7.036 26.767-4.493 39.892.196.438.156.872.31 1.304.459m32.014 5.533a50.198 50.198 0 0 0 9.87-1.514m18.85-9.106c10.656-7.408 20.23-17.185 33.79-24.356 13.228-6.995 27.411-6.762 39.657-.287l.032.126",
  stroke: "#46C3D7",
  opacity: 0.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("g", {
  transform: "translate(249 64)"
}, React.createElement("path", {
  d: "M7 5a1.5 1.5 0 1 0-2.998-.001 1.5 1.5 0 0 0 2.998 0",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M8.5 4.999A2.998 2.998 0 0 0 5.5 2a3 3 0 1 0 3 2.999",
  stroke: "#FFF",
  opacity: 0.5
}), React.createElement("path", {
  d: "M10.5 4.998A4.997 4.997 0 0 0 5.501 0 5 5 0 1 0 10.5 4.998",
  stroke: "#FFF",
  opacity: 0.25
})));

var SvgSids = function SvgSids(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 289 215",
    width: 414,
    height: 308,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSids, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sids.9165ad22.svg";
export { ForwardRef as ReactComponent };